import { render, staticRenderFns } from "./covidTemperature.vue?vue&type=template&id=879ca020&"
import script from "./covidTemperature.vue?vue&type=script&lang=js&"
export * from "./covidTemperature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports